module.exports = __webpack_public_path__ + "img/plot.894d3cd7.svg";